/**
 * Global utilities and initialization
 * Moved from main.tsx for React Router v7 framework mode compatibility
 */

import { toast } from 'react-toastify';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// La télémétrie n'est chargée que si l'environnement fournit une chaîne de
// connexion. La clé codée en dur d'origine était refusée par le service :
// « 400 dc.services.visualstudio.com/v2/track » en boucle dans la console, en
// local comme sur DEV, pour rien (relecture du 21.09, UPT-1972). Pour la
// réactiver : VITE_APPINSIGHTS_CONNECTION_STRING dans l'environnement du build.
const appInsightsConnectionString: string | undefined = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;
const appInsights = appInsightsConnectionString
    ? new ApplicationInsights({ config: { connectionString: appInsightsConnectionString } })
    : null;

if (appInsights && typeof window !== 'undefined') {
    appInsights.loadAppInsights();
    appInsights.trackPageView();
}

export { appInsights };

// Display error toast utility
export const displayError = (jsxMessage: any, toastId?: any, onClose?: any) => {
    toast.error(jsxMessage, {
        position: "top-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: toastId,
        theme: 'light',
        onClose: onClose
    });
};

// String prototype extension
if (typeof String.prototype.toProperCase === 'undefined') {
    // @ts-ignore
    String.prototype.toProperCase = function () {
        return this.replace(/\w\S*/g, function(txt: string){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
}
